import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	search: "",
	currentPage: 1,
	pages: 0,
	sortBy: "",
};

const filterSlice = createSlice({
	name: "filters",
	initialState,
	reducers: {
		setSearch: (state, action) => {
			state.search = action.payload;
		},
		setCurrentPage: (state, action) => {
			state.currentPage = action.payload;
		},
		setSortBy: (state, action) => {
			state.sortBy = action.payload;
		},
	},
});

export default filterSlice.reducer;
export const { setCurrentPage, setSearch, setSortBy } = filterSlice.actions;
